import { CoreIcon } from '../core-icon';
import motoFrontFillSVG from '../../assets/icons/moto-front-fill.svg';
import type { IconProps } from '../core-icon';

export const MotoFrontFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={motoFrontFillSVG} {...props} />;
};
